import { Component, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-betting-action-banner',
  templateUrl: './betting-action-banner.component.html',
  styleUrls: ['./betting-action-banner.component.scss']
})
export class BettingActionBannerComponent {

  @Input() betString: SafeHtml;
  @Input() oddsString: SafeHtml;
  @Input() oddsTextColour: string;
  @Input() destination: string;

  @Input() buttonBackgroundColour: string;
  @Input() buttonTextColour: string;
  @Input() desktopButtonString: SafeHtml;
  @Input() mobileButtonString: SafeHtml;

  @Input() desktopImageURL: string;
  @Input() desktopImageAltText: string;
  @Input() mobileImageURL: string;
  @Input() mobileImageAltText: string;

  @Input() clickProps: string;


  constructor() { }

}
